var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('LayoutBase',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"PageFaq",attrs:{"role":"main"}},[_c('Breadcrumbs',{attrs:{"links":_vm.breadcrumbs}}),_c('AppTitle',{staticClass:"Title--alpha vr-mb-2",attrs:{"heading-level":1}},[_vm._v(" "+_vm._s(_vm.$t('PageFiles.heading'))+" ")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }